var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.3772,
    r: 13.5293,
    fill: "url(#paint0_linear_4229_8205)",
    stroke: "url(#paint1_linear_4229_8205)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7564 20.8772V18.8545L15.0007 15.1386C15.3189 14.8507 15.5897 14.5874 15.8132 14.3488C16.0367 14.1064 16.2071 13.8639 16.3246 13.6215C16.442 13.3753 16.5007 13.1083 16.5007 12.8204C16.5007 12.4984 16.4306 12.2238 16.2905 11.9965C16.1503 11.7655 15.9571 11.5874 15.7109 11.4624C15.4647 11.3374 15.1825 11.2749 14.8643 11.2749C14.5424 11.2749 14.2602 11.3412 14.0178 11.4738C13.7753 11.6026 13.5859 11.7901 13.4496 12.0363C13.317 12.2825 13.2507 12.5817 13.2507 12.934H10.5859C10.5859 12.1423 10.764 11.4586 11.12 10.8829C11.4761 10.3071 11.9761 9.86394 12.62 9.55333C13.2678 9.23894 14.0196 9.08174 14.8757 9.08174C15.7583 9.08174 16.5253 9.22947 17.1768 9.52492C17.8284 9.82038 18.3321 10.2333 18.6882 10.7636C19.0481 11.2901 19.228 11.9018 19.228 12.5988C19.228 13.042 19.139 13.4814 18.9609 13.917C18.7829 14.3526 18.4628 14.8336 18.0007 15.3602C17.5424 15.8867 16.8909 16.5173 16.0462 17.2522L14.6541 18.5363V18.6102H19.37V20.8772H10.7564Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4229_8205",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4229_8205",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank2);
export default __webpack_public_path__ + "static/media/rank2.64ca5eb2936b888539df1c504319bc76.svg";
export { ForwardRef as ReactComponent };